import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LocalstorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class FatherService {

  host = '';
  config: any;

  constructor(
    protected httpClient: HttpClient,
    protected localstorageService: LocalstorageService
  ) {
    this.host = AppConfig.production ? `${AppConfig.API_BACKAND_SERVER}` : '';
  }


  get(url: string): Observable<any> {
    return this.httpClient.get(`${this.host}${url}`, {observe: 'response'})
      .pipe(map((response: any) => response.body));
  }

  post(url: string, data: any): Observable<any> {
    return this.httpClient.post(`${this.host}${url}`, data, {observe: 'response'})
      .pipe(map((response: any) => response.body));
  }

  patch(url: string, data: any): Observable<any> {
    return this.httpClient.patch(`${this.host}${url}`, data, {observe: 'response'})
      .pipe(map((response: any) => response.body));
  }

  delete(url: string): Observable<any> {
    return this.httpClient.delete(`${this.host}${url}`, {observe: 'response'})
      .pipe(map((response: any) => response.body));
  }

  catchError(error: any) {
    if (error.status === 500 || error.status === 403) {
      localStorage.clear();
      window.location.reload();
    } else {
      console.log(error.error ? error.error.message : error.message);
    }
  }


}
